import { useFormContext, useWatch } from 'react-hook-form'
import { CurecallToggle } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { EVariableType } from 'src/types/variable'
import { TNodeFormValues, TNodeImageVariable } from '../../node.type'
import { useChatbotFlow } from '../../chatbot.provider'
import { MEDIA_NOT_UPLOADED_HANDLE } from '../../chatbot.constants'

export function NodeMediaRequiredToggle() {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext<TNodeFormValues>()
  const { updateCurrentNodeData, removeEdgesFromHandle, selectedNodeId } = useChatbotFlow()

  const variable = useWatch({ control, name: 'variable' })

  if (variable?.type !== EVariableType.MEDIA) {
    return null
  }

  const handleChange = (isRequired: boolean) => {
    const updatedVariable: TNodeImageVariable = { ...variable, isRequired }
    setValue('variable', updatedVariable, { shouldDirty: true })
    updateCurrentNodeData({ variable: updatedVariable })
    if (isRequired && selectedNodeId) {
      removeEdgesFromHandle(selectedNodeId, MEDIA_NOT_UPLOADED_HANDLE)
    }
  }

  return (
    <div className="c-px-4 c-pb-4">
      <CurecallToggle
        leftLabel={t('pages.configuration.followups.chatbot.node-form.media-required')}
        isEnabled={variable.isRequired !== false}
        onChange={handleChange}
      />
    </div>
  )
}
